import moment, { Moment } from "moment";

type Format = "DD.MM.YYYY" | "YYYY-MM-DD";
export const formatDate = (date: string | Moment | null, format: Format = "DD.MM.YYYY") => {
  return moment(date).isValid() ? moment(date).format(format) : null;
};

export const formattedDate = (date) => (date ? moment(date).format("DD.MM.YYYY") : "");

export const formatDateTime = (date: string) =>
  moment.utc(date).local().format("DD.MM.YYYY, HH:mm:ss");

export const getDateFromNow = (date: string) => moment.utc(date).local().fromNow();
